import { useState } from 'react';

import { TranslationService } from '@/utils/services/TranslationService';

import useActiveGroup from '@/utils/hooks/user/useActiveGroup';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';
import useIsGroup from '@/utils/hooks/user/useIsGroup';

import { useProfilesStore } from '@/utils/zustand/providers/profiles-provider';

import { SCHEDULER_FEED_VIEW } from '@/lib/routes/privateRoutes';

import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';
import FeedPreview from '@/components/pages/scheduler/feed/FeedPreview';
import MobileViewAccessModal from '@/components/pages/scheduler/restrictAccessModals/MobileViewAccessModal';
import SchedulerAccessRights, {
    ModalRestrictionPage
} from '@/components/pages/scheduler/SchedulerAccessRights';
import SchedulerHeader from '@/components/pages/scheduler/SchedulerHeader/SchedulerHeader';
import { PageContentWrapper } from '@/components/layouts/LayoutPlatform/components/PageContentWrapper';

const SchedulerFeedViewContent = ({ hasSchedulerPermission }) => {
    const isGroup = useIsGroup();
    const { activeGroup } = useActiveGroup();
    const { activeSocialProfile } = useActiveSocialProfile();
    const [needReloadScheduledPosts, setNeedReloadScheduledPosts] = useState(false);

    return (
        <>
            <SchedulerHeader
                isGroup={isGroup}
                activeGroup={activeGroup}
                activeSocialProfile={activeSocialProfile}
                hasSchedulerPermission={hasSchedulerPermission}
                setNeedReloadScheduledPosts={setNeedReloadScheduledPosts}
            />
            <PageContentWrapper>
                <div className="relative z-0 flex h-full flex-1 flex-col overflow-hidden rounded-t-md">
                    <FeedPreview
                        needReloadScheduledPosts={needReloadScheduledPosts}
                        setNeedReloadScheduledPosts={setNeedReloadScheduledPosts}
                    />
                    <ModalRestrictionPage
                        activeSocialProfile={activeSocialProfile}
                        hasSchedulerPermission={hasSchedulerPermission}
                    />
                    <MobileViewAccessModal />
                </div>
            </PageContentWrapper>
        </>
    );
};

const SchedulerIntermediateFeedViewContent = () => {
    const isGroup = useIsGroup();
    const { activeSocialProfile } = useActiveSocialProfile();
    const { activeMultiSelectionProfiles } = useProfilesStore((state) => state);

    if (
        isGroup ||
        (activeMultiSelectionProfiles?.socialProfileIds?.length > 1 && !activeSocialProfile)
    ) {
        return <SchedulerFeedViewContent hasSchedulerPermission={true} />;
    }

    return (
        <SchedulerAccessRights isFullHeight className="h-full !min-h-0 flex-1 lg:!max-h-screen">
            {({ hasSchedulerPermission }) => (
                <SchedulerFeedViewContent hasSchedulerPermission={hasSchedulerPermission} />
            )}
        </SchedulerAccessRights>
    );
};

const SchedulerFeedView = () => {
    return (
        <WrapperSwitchLayout
            noPadding
            className="px-5 pt-5 sm:px-8 sm:pt-8"
            bodyWrapperClass="!pb-0">
            <SchedulerIntermediateFeedViewContent />
        </WrapperSwitchLayout>
    );
};

export const getStaticProps =
    TranslationService.getTranslationMessagesFromRoute(SCHEDULER_FEED_VIEW);

export default SchedulerFeedView;
